<template>
  <div>
    <div class="vx-row m-2">
      <div class="router-header flex flex-wrap items-center mb-6 mt-5">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
        >
          <h2 class="mb-1">{{ $t("notification") }}</h2>
        </div>
      </div>
    </div>
    <vs-card class="px-10 py-5">
      <div>
        <vs-table
          maxHeight="460px"
          search
          class="static"
          :max-items="descriptionItems[0]"
          description
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
          pagination
          :data="notification"
          v-model="selected"
          @selected="handleSelected"
        >
          <template slot="header">
            <h4 class="mb-5">
              {{ $t("notification") }}
            </h4>
          </template>
          <template slot="thead">
            <vs-th>
              {{ $t("RefineryTable.Id") }}
            </vs-th>
            <vs-th sort-key="created_at">
              {{ $t("RefineryTable.TransferStart") }}
            </vs-th>
            <vs-th>
              {{ $t("RefineryTable.Detail") }}
            </vs-th>
            <!-- <vs-th>
              {{ $t("destinationType") }}
            </vs-th> -->
            <vs-th sort-key="read_at">
              {{ $t("RefineryTable.ReadAt") }}
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ indextr + 1 }}
              </vs-td>
              <vs-td :data="data[indextr].created_at">
                {{ setDateFormat(data[indextr].created_at) }}
              </vs-td>
              <vs-td :data="data[indextr].to_s">
                {{ data[indextr].to_s }}
              </vs-td>
              <!-- <vs-td :data="data[indextr].vessel_trip.destination_type">
                <p v-if="data[indextr].vessel_trip.destination_type == 'export'" >
                  {{ $t("exportOil") }}
                </p>
                <p v-else-if="data[indextr].vessel_trip.destination_type == 'transit'">
                  {{ $t("greenDiesel") }}
                </p>
                <p v-else>{{ $t("domesticOil") }}</p>
              </vs-td> -->
              <vs-td
                v-if="data[indextr].read_at != null"
                :data="data[indextr].read_at"
              >
                <font color="#006600">{{
                  setDateFormat(data[indextr].read_at)
                }}</font>
              </vs-td>
              <vs-td v-else :data="data[indextr].read_at">
                <font color="warning">ยังไม่อ่าน</font>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { OIL_TYPE } from "../constant/index";

export default {
  name: "Notification",
  data() {
    return {
      descriptionItems: [10, 25, 50, 100],
      selected: [],
    };
  },
  watch: {
    notification(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        // this.getNotificationsData();
      }
    },
    loading(loading) {
      if (loading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
  },
  computed: {
    ...mapState({
      notification: (state) => state.vesselTrip.notificationData,
      loading: (state) => state.vesselTrip.loading,
      isGreenDieselActive: (state) => state.isGreenDieselActive,
      isDomesticOilActive: (state) => state.isDomesticOilActive,
      isExportOilActive: (state) => state.isExportOilActive,
    }),
  },
  mounted() {
    this.$store.dispatch("activeOilCard", OIL_TYPE.ALL);
    this.getNotificationsData();
  },
  methods: {
    getNotificationsData() {
      this.$store.dispatch("getEventNotificationsData");
    },
    setDateFormat(date) {
      const locale = this.$i18n.locale;
      if (locale == 'th') {
        const newDate = moment(date).add(543, 'years').format('DD/MM/YYYY HH:mm');
        return newDate
      }
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    async handleSelected(tr) {
      console.log(tr.id, tr.vessel_trip_id);
      this.$store.dispatch("markEventNotificationsAsRead", tr.id);
      this.$store.dispatch("getEventNotificationsData");
      localStorage.setItem("vesselTripId", tr.vessel_trip_id);
      // this.$router.push("/printNotification");
      let routeData = this.$router.resolve("/printNotification");
      window.open(routeData.href, '_blank');
      location.reload();
    },
  },
};
</script>

<style>
.tableship {
  height: 100%;
}
@media print {
  #selecttime {
    display: none;
  }
}
</style>
